/**
 * Décor du bandeau d'une carte de voyage.
 *
 * Quatre paysages dessinés plutôt que des photographies : rien à télécharger,
 * rien qui vieillisse, et une teinte qui reste dans la palette. Ils ne
 * décrivent pas la destination — on ne la connaît pas — mais donnent à chaque
 * carte une silhouette reconnaissable dans la grille.
 */

function Ville({ id }) {
  return (
    <>
      <rect width="200" height="100" fill={`url(#${id})`} />
      <g fill="#fff" opacity="0.34">
        <rect x="18" y="52" width="20" height="48" rx="2" />
        <rect x="44" y="38" width="16" height="62" rx="2" />
        <rect x="66" y="60" width="22" height="40" rx="2" />
        <rect x="94" y="30" width="18" height="70" rx="2" />
        <rect x="118" y="55" width="24" height="45" rx="2" />
        <rect x="148" y="44" width="16" height="56" rx="2" />
        <rect x="170" y="64" width="18" height="36" rx="2" />
      </g>
      <circle cx="164" cy="24" r="9" fill="#fff" opacity="0.5" />
    </>
  );
}

function Mer({ id }) {
  return (
    <>
      <rect width="200" height="100" fill={`url(#${id})`} />
      <circle cx="150" cy="30" r="13" fill="#fff" opacity="0.48" />
      <g fill="#fff" opacity="0.3">
        <path d="M0 66 Q 25 56, 50 66 T 100 66 T 150 66 T 200 66 V100 H0 Z" />
      </g>
      <g fill="#fff" opacity="0.24">
        <path d="M0 80 Q 25 70, 50 80 T 100 80 T 150 80 T 200 80 V100 H0 Z" />
      </g>
    </>
  );
}

function Montagne({ id }) {
  return (
    <>
      <rect width="200" height="100" fill={`url(#${id})`} />
      <g fill="#fff" opacity="0.28">
        <path d="M-10 100 L 55 34 L 105 100 Z" />
        <path d="M75 100 L 135 44 L 200 100 Z" />
      </g>
      <path d="M38 52 L 55 34 L 72 52 Z" fill="#fff" opacity="0.5" />
      <circle cx="168" cy="26" r="8" fill="#fff" opacity="0.45" />
    </>
  );
}

function Collines({ id }) {
  return (
    <>
      <rect width="200" height="100" fill={`url(#${id})`} />
      <g fill="#fff" opacity="0.26">
        <path d="M-10 100 Q 40 58, 90 100 Z" />
        <path d="M60 100 Q 120 52, 190 100 Z" />
      </g>
      <g stroke="#fff" strokeWidth="2" opacity="0.42" strokeLinecap="round">
        <path d="M32 92 V 76" />
        <path d="M150 94 V 80" />
      </g>
      <g fill="#fff" opacity="0.42">
        <circle cx="32" cy="72" r="7" />
        <circle cx="150" cy="76" r="6" />
      </g>
    </>
  );
}

const PAYSAGES = [Ville, Mer, Montagne, Collines];

const DEGRADES = [
  ['#cfe0f2', '#dcd9f0'],
  ['#d6dcf1', '#c9e6dc'],
  ['#c6e4d9', '#d5e6f2'],
  ['#f0dcd2', '#e2dcf0'],
];

export function Paysage({ variante = 0 }) {
  const index = ((variante % PAYSAGES.length) + PAYSAGES.length) % PAYSAGES.length;
  const Motif = PAYSAGES[index];
  // Identifiant unique par variante : plusieurs cartes coexistent dans la
  // grille, et deux dégradés portant le même id se confondraient.
  const id = `paysage-${index}`;
  const [debut, fin] = DEGRADES[index];

  return (
    <svg
      className="paysage"
      viewBox="0 0 200 100"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={debut} />
          <stop offset="100%" stopColor={fin} />
        </linearGradient>
      </defs>
      <Motif id={id} />
    </svg>
  );
}
